module.exports = __webpack_public_path__ + "img/max-file-approve--csv.86d11791.svg";